import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import styles from "./ClientOrgs.module.scss"

const ProblemStatement = props => {
  return (
    <section className={styles.section + " container-fluid bg-xl-light-gray"}>
      <div className="row ml-0 mr-0">
        <Wrapper className="w-100" gap="outer">
          <WrapperInner className={styles.wrapperInner + " row"}>
            <div className="col-12">
              <div
                className={
                  styles.introContent + " text-white text-center m-auto"
                }
              >
                <h3>
                  <TopTitle content="WHO WE WORK WITH" />
                  <div className="proxima-nova--extra-bold fs-30pt fs-lg-40pt fs-xl-50pt mb-4">
                    WE WORK WITH ORGANIZATIONS IN ALL INDUSTRIES
                  </div>
                </h3>
                <p
                  className={
                    styles.description +
                    " proxima-nova--light fs-18pt fs-xl-22pt"
                  }
                >
                  Our clients come to us because they want to:
                </p>
              </div>
            </div>
            <div className="col-12 text-secondary">
              <ul
                className={
                  styles.list +
                  " proxima-nova--semi-bold fs-16pt fs-lg-18pt fs-xl-21pt"
                }
              >
                <li>
                  Improve productivity and efficiency in the workplace for their
                  employees and IT team.
                </li>
                <li>
                  Simplify the management of unique logins and passwords for
                  their employees.
                </li>
                <li>
                  Eliminate the manual task of setting up and removing employee
                  user accounts.
                </li>
                <li>
                  Increase the overall digital security of the company and
                  employee data.
                </li>
              </ul>
              <p class="text-white fs-18pt">
                Our clients are forward-thinking, enthusiastic about their
                business and are committed to improving productivity, digital
                security and saving costs and believe they can do this with the
                right team to support and work with them.
              </p>
            </div>
          </WrapperInner>
        </Wrapper>
      </div>
    </section>
  )
}

export default ProblemStatement
